// Courses Filter Component Scripts using Alpine.js

import { Alpine } from '@webikon/webentor-core/_alpine';

interface CoursesFilterData {
  isExpanded: boolean;
  courseTypesFieldSelector: string;
  showText: string;
  hideText: string;
  $el?: HTMLElement;
  init(): void;
  toggleFilters(): void;
  removeFilterType(typeSlug: string): void;
  toggleButtonText: string;
}

export default function coursesFilter(): CoursesFilterData {
  return {
    isExpanded: false,
    courseTypesFieldSelector: '',
    showText: '',
    hideText: '',

    init() {
      // Get text strings from data attributes
      const container = this.$el as HTMLElement;
      this.showText = container.dataset.showText || '';
      this.hideText = container.dataset.hideText || '';
      this.courseTypesFieldSelector = container.dataset.fieldSelector || '';
    },

    toggleFilters() {
      this.isExpanded = !this.isExpanded;
    },

    removeFilterType(typeSlug: string) {
      // Find all checkboxes with this value
      const checkboxes = document.querySelectorAll<HTMLInputElement>(
        `input[name="${this.courseTypesFieldSelector}[]"][value="${typeSlug}"]`,
      );

      if (checkboxes.length > 0) {
        // Uncheck all matching checkboxes
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });

        // Submit the form using the first checkbox found
        const form = checkboxes[0].form;
        if (form) {
          form.submit();
        }
      } else {
        // Fallback: try to find any checkbox with this value
        const fallbackCheckbox = document.querySelector<HTMLInputElement>(
          `input[value="${typeSlug}"]`,
        );
        if (fallbackCheckbox) {
          fallbackCheckbox.checked = false;
          const form = fallbackCheckbox.form;
          if (form) {
            form.submit();
          }
        }
      }
    },

    get toggleButtonText() {
      return this.isExpanded ? this.hideText : this.showText;
    },
  };
}

// Register Alpine component
Alpine.data('coursesFilter', coursesFilter);
